import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { Documentos } from '@/features/documentos/componentes/Documentos';
import { rotaDeTela } from '@/features/permissoes/guardas';

const busca = z.object({
  busca: z.string().optional().catch(undefined),
  visibilidade: z.enum(['privado', 'publico', 'pago']).optional().catch(undefined),
  categoria: z.enum(['dieta', 'treino', 'guia', 'receitas', 'outro']).optional().catch(undefined),
  arquivados: z.boolean().optional().catch(undefined),
  cursor: z.string().optional().catch(undefined),
  tags: z.string().optional().catch(undefined),
});

/** Documentos (PDF) dos alunos (spec 018, CA-01). */
export const Route = createFileRoute('/_autenticado/documentos/')({
  ...rotaDeTela('documentos.lista'),
  validateSearch: busca,
  component: Pagina,
});

function Pagina() {
  const filtros = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <Documentos
      filtros={filtros}
      aoMudarFiltros={(novos) => {
        void navigate({ search: novos, replace: true });
      }}
    />
  );
}
